import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';

import { VideaTypography } from '../../common-components/elements/VideaTypography/VideaTypography';
import { blueBlack500, white } from '../../theme/videa-style-tokens';

const BlankCard = styled.div`
  border-radius: 0.75em;
  box-sizing: border-box;
  flex-basis: 33%;
  background-color: ${blueBlack500};
  opacity: 40%;
`;

const ComingSoonCard = styled.div`
  position: absolute;
  top: 12em;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 37.5em;
  padding: 2em 3em;
  border-radius: 0.75em;
  background-color: ${white};
  box-shadow: 0 0.375em 0.375em 0 #00000040;

  h1 {
    margin-bottom: 1em;
  }
`;
export const ComingSoon = ({
  isInvalidOnboardingDate,
}: {
  isInvalidOnboardingDate?: boolean;
}) => {
  return (
    <>
      <BlankCard data-testid="blank-card" />
      <BlankCard data-testid="blank-card" />
      <BlankCard data-testid="blank-card" />
      <ComingSoonCard data-testid="coming-soon-card">
        <VideaTypography variant="headingSmall" component="h1">
          {isInvalidOnboardingDate
            ? "Your practice's metrics will be available once a full month from your onboarding date has passed."
            : 'This feature is coming soon.'}
        </VideaTypography>
        <VideaTypography variant="bodyExtrasmall">
          <Trans>
            Please <a href="mailto:support@videa.ai">contact VideaAI Support</a>{' '}
            if you have any questions.
          </Trans>
        </VideaTypography>
      </ComingSoonCard>
    </>
  );
};
